import {Mapper} from '@s-ui/domain'

export default class HTTPUserRepositoryToContactResponseValueObjectMapper extends Mapper {
  constructor({config, contactResponseValueObjectFactory}) {
    super()
    this._config = config
    this._contactResponseValueObjectFactory = contactResponseValueObjectFactory
  }

  map = response => {
    const {data: {token, userId} = {}, status} = response
    const responseStatusLiteral =
      this._config.get('USER_CONTACT_BY_MAIL_RESPONSES')[status] ||
      this._config.get('DEFAULT_USER_CONTACT_BY_MAIL_RESPONSE')
    return this._contactResponseValueObjectFactory({
      ...responseStatusLiteral,
      contactToken: token,
      contactUserId: userId
    })
  }
}
